var _defs, _path, _path2, _path3, _path4, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButterflyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "butterfly-grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C9BBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ECD9BA"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32 C28 20, 8 10, 4 22 C2 30, 14 36, 32 32Z",
    fill: "url(#butterfly-grad)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32 C26 42, 6 46, 8 56 C10 62, 24 56, 32 32Z",
    fill: "url(#butterfly-grad)",
    opacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32 C36 20, 56 10, 60 22 C62 30, 50 36, 32 32Z",
    fill: "url(#butterfly-grad)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32 C38 42, 58 46, 56 56 C54 62, 40 56, 32 32Z",
    fill: "url(#butterfly-grad)",
    opacity: 0.85
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 38,
    rx: 2,
    ry: 8,
    fill: "url(#butterfly-grad)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 26,
    rx: 1.5,
    ry: 6,
    fill: "url(#butterfly-grad)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButterflyLogo);
export default __webpack_public_path__ + "static/media/butterfly-logo.ea2938c2e1ce64d17118a42a6cc674f5.svg";
export { ForwardRef as ReactComponent };